export default "__VITE_ASSET__349a3a31__"